import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-skeleton-appointment',
  templateUrl: './skeleton-appointment.component.html',
  styleUrls: ['./skeleton-appointment.component.scss']
})
export class SkeletonAppointmentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
